// src/pages/PaymentSuccess.jsx
import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle, ArrowLeft, ExternalLink } from 'lucide-react';
import api from '../api/api';
import { Helmet } from 'react-helmet-async';
export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);

  const bookingId = searchParams.get('bookingId');

  useEffect(() => {
    if (bookingId) fetchBookingStatus();
  }, [bookingId]);

  const fetchBookingStatus = async () => {
    try {
      const res = await api.get(`/bookings/${bookingId}/status`);
      setBooking(res.data.booking);
    } catch (error) {
      console.error('Error fetching booking:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[100vh] w-full flex items-center justify-center p-4 bg-gradient-to-br from-green-50 to-green-200 dark:from-green-900/30 dark:to-green-700/20">
<Helmet>
  <title>Payment Successful — YS Sky Travel and Tour Agency P.L.C</title>
  <meta name="description" content="Your payment was completed successfully." />
</Helmet>

      <div className="bg-white dark:bg-slate-900 rounded-3xl shadow-xl p-8 md:p-10 max-w-lg w-full text-center animate-fadeIn">

        <div className="flex justify-center mb-6">
          <CheckCircle className="w-20 h-20 text-green-500 drop-shadow-lg animate-bounce" />
        </div>

        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-3">
          Payment Successful!
        </h1>

        <p className="text-gray-600 dark:text-gray-400 text-base md:text-lg leading-relaxed mb-8">
          Your booking and payment were completed successfully.  
          Thank you for choosing us!
        </p>

       

        <div className="space-y-4">
          <Link
            to="/profile"
            className="w-full flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white py-3 rounded-xl font-semibold transition-all duration-200 shadow-md hover:shadow-lg"
          >
            <ExternalLink className="w-5 h-5" />
            View My Bookings
          </Link>

          <Link
            to="/tours"
            className="w-full flex items-center justify-center gap-2 bg-gray-100 dark:bg-slate-800 hover:bg-gray-200 dark:hover:bg-slate-700 text-gray-700 dark:text-gray-300 py-3 rounded-xl font-semibold transition-all duration-200 shadow-sm"
          >
            <ArrowLeft className="w-5 h-5" />
            Browse More Tours
          </Link>
        </div>
      </div>
    </div>
  );
}
